import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledGoogleApproverBox = styled(Box)`
  display: flex;
  height: 100%;
`;
